module.exports = __webpack_public_path__ + "img/logobelakasa.c2997df7.png";